export default "__VITE_ASSET__1fd99325__"